import { Outlet } from 'react-router-dom';
import ContainerAcolherVisitante from './components/container';
import { ProviderGetMembrosAcolher } from './context/getAcolher';

export default function Visitante() {
  return (
    <>
      <ProviderGetMembrosAcolher>
        <div style={{ display: "flex", flex: 1, padding: 5 }}>
          <ContainerAcolherVisitante />
        </div>
        <Outlet/>
      </ProviderGetMembrosAcolher>
    </>
  )
}


 {/* <Formulario
                tituloFiltro={false}
                tituloFormulario='Visitantes'
                atualizar={true}
                urlFiltroPesquisarPrincipal={''}
                urlFiltroPesquisarSegundario={''}
                tituloFiltroSelecoes={'Eventos'}
                identificador={'id'}
                alterar={true}
                cabecalhoDeRelatorios={["Nome", "Email", "Telefone"]}
                conteudoRelatorios={["nome", "email", "telefone"]}
                descricaoDoFiltro='nome'
                exportar={true}
                filtrar={true}
                url={"https://logtech.solutions:9292/visitante"}
                cabeca={["Nome", "Email", "Telefone", "Data"]}
                conteudo={["nome", "email", "telefone", "inscricao"]}
                urlAlteracao={`https://logtech.solutions:9292/visitante`}
            /> */}
